import { createReactI18n } from '@w/react-i18n'
import { uiI18n } from '@w/ui/i18n'
import type { en } from './translations/en'

export const appI18n = createReactI18n({
  fallbackLocale: 'en',
  localStorageKey: 'dev-app-locale',
  loadTranslation: async (locale) => {
    const module = (await import(`./translations/${locale}.ts`)) as Record<
      'en' | 'ru',
      typeof en
    >
    return module[locale as 'en' | 'ru']
  },
})

// Forward library i18n to app's i18n system
uiI18n.setAppTranslations(appI18n)

// oxlint-disable-next-line typescript/unbound-method -- createReactI18n returns bound helpers
export const { useTranslation, I18nProvider, setLocale, useLocale } = appI18n
